import React, { useState, useEffect, useMemo } from 'react'; // Ajout de useMemo
import { useParams, Link } from 'react-router-dom';
import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Form,
  Row,
  Table,
  Modal,
  Container, // Ajouté pour la structure globale
  Spinner, // Ajouté pour le chargement
  Nav,
  OverlayTrigger, // AJOUTEZ CETTE LIGNE
  Tooltip // AJOUTEZ CETTE LIGNE
} from 'react-bootstrap';
import * as Moment from 'moment';
import NavbarStandard from '@commons/NavbarStandard';
import Section from '@common/Section';
import api from '@services/api';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers,
  faPlus,
  faTrash,
  faListAlt,
  faBuilding,
  faHandshake,
  faArrowLeft,
  faCalendar,
  faClock,
  faBusinessTime,
  faUserClock,
  faUserPlus,
  faUser,
  faStar,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons';

const SalonDetail = () => {
  const { id: salonId } = useParams(); // Renommé en salonId pour clarté
  const [loading, setLoading] = useState(true);
  const [salon, setSalon] = useState(null);
  const [participants, setParticipants] = useState([]); // Participants du partenaire
  const [allPartners, setAllPartners] = useState([]);
  const [existingWishes, setExistingWishes] = useState([]); // Vœux des participants du partenaire
  const [searchCompany, setSearchCompany] = useState('');
  const [showAddParticipantModal, setShowAddParticipantModal] = useState(false); // Renommé pour clarté
  const [showOnlyWishedToggle, setShowOnlyWishedToggle] = useState(false); // Modifié: initialisé à false
  const [activeTab, setActiveTab] = useState('summary');
  const [selectedUserIdToAdd, setSelectedUserIdToAdd] = useState(''); // AJOUTER CETTE LIGNE
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false); // Pour la confirmation de suppression
  const [participantToDelete, setParticipantToDelete] = useState(null); // Pour la suppression
  const [showFavoritePartnersModal, setShowFavoritePartnersModal] =
    useState(false);
  const [
    selectedFavoritePartnerIdsInModal,
    setSelectedFavoritePartnerIdsInModal
  ] = useState([]);
  const [eligibleUsers, setEligibleUsers] = useState([]); // Pour stocker les utilisateurs éligibles
  const isSalonVisible =
    salon?.registration_start_date && salon?.date
      ? new Date(salon.registration_start_date) <= new Date() &&
        new Date() <=
          new Date(salon.date).setDate(new Date(salon.date).getDate() + 3)
      : false;

  useEffect(() => {
    fetchSalonDetails();
  }, [salonId]);

  const fetchSalonDetails = async () => {
    setLoading(true);
    try {
      // Nouvelle route API
      const response = await api.get(
        `/member/partner-salons/${salonId}/details`
      );

      if (response.data.success) {
        const {
          salon: salonData,
          participants: participantsData,
          all_partners: allPartnersDataFromApi,
          existing_wishes: existingWishesData
        } = response.data.data;

        setSalon(salonData);
        setParticipants(participantsData || []);
        setAllPartners(allPartnersDataFromApi || []);
        setExistingWishes(existingWishesData || []);
        setEligibleUsers(response.data.data.eligible_users || []); // Récupération des utilisateurs éligibles

        let hasAtLeastOneFavorite = false;
        if (allPartnersDataFromApi && allPartnersDataFromApi.length > 0) {
          // Vérifie si au moins un partenaire dans la liste est marqué comme favori
          hasAtLeastOneFavorite = allPartnersDataFromApi.some(
            partner => partner.is_favorite
          );
        }

        if (
          !hasAtLeastOneFavorite &&
          allPartnersDataFromApi &&
          allPartnersDataFromApi.length > 0
        ) {
          setShowFavoritePartnersModal(true);
        }
      } else {
        toast(
          response.data.data?.error ||
            'Impossible de charger les détails du salon'
        );
      }
    } catch (error) {
      console.error('Erreur lors du chargement des détails du salon:', error);
      toast('Une erreur est survenue lors du chargement des données');
    } finally {
      setLoading(false);
    }
  };

  const addParticipant = async () => {
    if (!selectedUserIdToAdd) {
      toast('Veuillez sélectionner un collaborateur.');
      return;
    }
    try {
      const response = await api.post(
        `/member/partner-salons/${salonId}/participants`,
        { user_id: parseInt(selectedUserIdToAdd, 10) } // MODIFIÉ: Envoyer user_id
      );

      if (response.data.success) {
        setSelectedUserIdToAdd(''); // MODIFIÉ: Réinitialiser la sélection
        setShowAddParticipantModal(false);
        toast('Participant ajouté avec succès');
        await fetchSalonDetails(); // Recharger toutes les données
        setActiveTab(response.data.data.id.toString()); // Passer à l'onglet du nouveau participant
      } else {
        toast(response.data.message || "Erreur lors de l'ajout du participant");
      }
    } catch (error) {
      console.error("Erreur lors de l'ajout du participant:", error);
      toast(error.response?.data?.message || 'Une erreur est survenue');
    }
  };

  const confirmDeleteParticipant = participant => {
    setParticipantToDelete(participant);
    setShowDeleteConfirm(true);
  };

  const deleteParticipant = async () => {
    if (!participantToDelete) return;
    try {
      // Nouvelle route API
      await api.delete(
        `/member/partner-salons/${salonId}/participants/${participantToDelete.id}`
      );
      setParticipants(
        participants.filter(p => p.id !== participantToDelete.id)
      );
      setExistingWishes(
        existingWishes.filter(
          wish => wish.partner_participant_id !== participantToDelete.id
        )
      );
      toast('Participant supprimé avec succès');
      if (activeTab === participantToDelete.id.toString()) {
        setActiveTab('summary');
      }
    } catch (error) {
      console.error('Erreur lors de la suppression du participant:', error);
      toast('Une erreur est survenue lors de la suppression');
    } finally {
      setShowDeleteConfirm(false);
      setParticipantToDelete(null);
    }
  };

  const toggleParticipantWish = async (
    participantId,
    companyId,
    currentIsWished
  ) => {
    const newIsWished = !currentIsWished;
    const numParticipantId = Number(participantId);
    const numCompanyId = Number(companyId);

    const maxWishes = salon?.max_wishes_per_participant;

    if (newIsWished) {
      const currentWishesForParticipant = existingWishes.filter(
        wish => wish.company_participant_id === participantId
      ).length;

      // Vérifier si maxWishes est défini et est un nombre
      if (typeof maxWishes === 'number') {
        if (maxWishes > 0 && currentWishesForParticipant >= maxWishes) {
          toast.warn(
            `Limite de ${maxWishes} vœux atteinte pour ce participant.`
          );
          return;
        }
      } else {
        console.warn(
          "max_wishes_per_participant n'est pas défini dans l'objet salon."
        );
      }
    }

    try {
      const response = await api.post(
        `/member/partner-salons/${salonId}/wishes`,
        {
          company_participant_id: numParticipantId,
          partner_id: numCompanyId,
          is_wished: newIsWished
        }
      );

      if (response.data.success) {
        if (newIsWished) {
          const newWishFromApi = response.data.data;
          setExistingWishes(prevWishes => [
            ...prevWishes,
            // Assurez-vous que les IDs dans newWishFromApi sont aussi des nombres si vous voulez être strict,
            // ou laissez isCompanyWishedByParticipant gérer la conversion à la lecture.
            // Pour la cohérence, il serait bon que l'API renvoie des nombres.
            {
              ...newWishFromApi,
              company_participant_id: Number(
                newWishFromApi.company_participant_id
              ),
              partner_id: Number(newWishFromApi.partner_id)
            }
          ]);
        } else {
          setExistingWishes(prevWishes =>
            prevWishes.filter(
              wish =>
                !(
                  // Le vœu est gardé si ce n'est PAS celui à supprimer
                  (
                    Number(wish.company_participant_id) === numParticipantId &&
                    Number(wish.partner_id) === numCompanyId
                  )
                )
            )
          );
        }
        toast(`Vœu ${newIsWished ? 'ajouté' : 'retiré'} avec succès`);
      } else {
        toast(
          response.data.message || 'Erreur lors de la mise à jour du souhait'
        );
      }
    } catch (error) {
      console.error('Erreur lors de la mise à jour du souhait:', error);
      toast('Une erreur est survenue lors de la mise à jour du souhait');
    }
  };

  const isCompanyWishedByParticipant = (participantId, companyId) => {
    // Convertit les IDs en nombres avant la comparaison pour éviter les problèmes de type
    const numParticipantId = Number(participantId);
    const numCompanyId = Number(companyId);

    return existingWishes.some(
      wish =>
        Number(wish.company_participant_id) == numParticipantId &&
        Number(wish.partner_id) == numCompanyId
    );
  };

  const getWishSummary = () => {
    return participants.map(participant => {
      const wishedCompaniesList = allPartners.filter(company =>
        isCompanyWishedByParticipant(participant.id, company.id)
      );
      return {
        participant,
        count: wishedCompaniesList.length,
        wishedCompanies: wishedCompaniesList
      };
    });
  };

  const handleTabChange = tabKey => {
    setActiveTab(tabKey);
    if (tabKey === 'add') {
      setShowAddParticipantModal(true);
    } else {
      setShowAddParticipantModal(false);
    }
  };

  const isRegistrationOpen = salon?.registration_end_date
    ? new Date(salon.registration_end_date) >= new Date()
    : true;

  const sortByPartnerCompanyAndName = (a, b) => {
    // Utilise la nouvelle propriété `is_favorite`
    if (a.is_favorite && !b.is_favorite) return -1;
    if (!a.is_favorite && b.is_favorite) return 1;
    return a.name.localeCompare(b.name);
  };

  const filteredCompaniesForDisplay = useMemo(() => {
    if (!searchCompany) {
      return allPartners;
    }
    return allPartners.filter(company =>
      company.name.toLowerCase().includes(searchCompany.toLowerCase())
    );
  }, [allPartners, searchCompany]);

  const handleFavoritePartnerSelectionInModal = partnerId => {
    setSelectedFavoritePartnerIdsInModal(prev =>
      prev.includes(partnerId)
        ? prev.filter(id => id !== partnerId)
        : [...prev, partnerId]
    );
  };

  const handleSaveFavoritePartners = async () => {
    try {
      const response = await api.post(
        `/member/partner-salons/favorite-partners`,
        {
          partner_ids: selectedFavoritePartnerIdsInModal
        }
      );
      if (response.data.success) {
        toast('Partenaires favoris enregistrés !');
        setShowFavoritePartnersModal(false);
        await fetchSalonDetails(); // Recharger les détails pour refléter les nouveaux favoris
      } else {
        toast(
          response.data.message ||
            "Erreur lors de l'enregistrement des favoris."
        );
      }
    } catch (error) {
      console.error('Erreur handleSaveFavoritePartners:', error);
      toast(error.response?.data?.message || 'Une erreur est survenue.');
    }
  };

  if (loading) {
    return (
      <>
        <NavbarStandard />
        <Section
          className="py-0 overflow-hidden light"
          position="center bottom"
        >
          <Container className="text-center mt-5 py-5">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Chargement...</span>
            </Spinner>
          </Container>
        </Section>
      </>
    );
  }

  if (!salon) {
    return (
      <>
        <NavbarStandard />
        <Section
          className="py-0 overflow-hidden light"
          position="center bottom"
        >
          <Container className="text-center mt-5 py-5">
            <Alert variant="danger">
              Salon non trouvé ou vous n'êtes pas autorisé à y accéder.
            </Alert>
            <div className="text-center mt-3 mb-3">
              <Link to="/espace-membre/accueil">
                <Button variant="primary">Retour à l'accueil</Button>
              </Link>
            </div>
          </Container>
        </Section>
      </>
    );
  }

  return (
    <>
      <NavbarStandard />
      <Section className="py-4 overflow-hidden light" position="center bottom">
        <Container>
          <Row className="mb-3 align-items-center">
            <Col xs="auto">
              <Button
                variant="outline-secondary"
                as={Link}
                to="/espace-membre/accueil"
              >
                <FontAwesomeIcon icon={faArrowLeft} />
              </Button>
            </Col>
            <Col>
              <h3 className="mb-0">{salon.name}</h3>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col xs={12}>
              <div className="d-flex flex-wrap">
                <Badge bg="light" text="dark" className="me-2 mb-2 border p-2">
                  <FontAwesomeIcon icon={faCalendar} className="me-1" />
                  Date: {Moment(salon.date).format('DD/MM/YYYY')}
                </Badge>
                <Badge bg="light" text="dark" className="me-2 mb-2 border p-2">
                  <FontAwesomeIcon icon={faClock} className="me-1" />
                  Horaires: {salon.start_time} - {salon.end_time}
                </Badge>
                <Badge bg="light" text="dark" className="me-2 mb-2 border p-2">
                  <FontAwesomeIcon icon={faBusinessTime} className="me-1" />
                  Durée des RDV: {salon.slot_duration} min
                </Badge>
                <Badge bg="light" text="dark" className="me-2 mb-2 border p-2">
                  <FontAwesomeIcon icon={faUserClock} className="me-1" />
                  Inscriptions jusqu'au:{' '}
                  {Moment(salon.registration_end_date).format('DD/MM/YYYY')}
                </Badge>
              </div>
            </Col>
          </Row>

          {isRegistrationOpen && (
            <Card className="mb-4 bg-light border-info">
              <Card.Body>
                <p className="mb-1">
                  <FontAwesomeIcon
                    icon={faHandshake}
                    className="me-2 text-info"
                  />
                  Pour chaque participant, cliquez sur les partenaires que vous
                  souhaitez rencontrer pour exprimer vos vœux.
                </p>
                <p className="mb-0">
                  <FontAwesomeIcon
                    icon={faBuilding}
                    className="me-2 text-info"
                  />
                  Les partenaires marqués comme "Favoris" sont ceux avec
                  lesquels vous travaillez régulièrement.
                </p>
              </Card.Body>
            </Card>
          )}

          {!isSalonVisible && (
            <Card className="mb-4 bg-light border-danger">
              <Card.Body>
                <p className="mb-0 text-danger">
                  <strong>
                    La période de sélection des vœux est terminée.
                  </strong>{' '}
                  Vous recevrez prochainement un email contenant votre planning.
                </p>
              </Card.Body>
            </Card>
          )}

          <Card>
            <Card.Header className="bg-light">
              <Nav
                variant="tabs"
                activeKey={activeTab}
                onSelect={handleTabChange}
              >
                <Nav.Item>
                  <Nav.Link eventKey="summary">
                    <FontAwesomeIcon icon={faListAlt} className="me-1" />{' '}
                    Récapitulatif
                  </Nav.Link>
                </Nav.Item>
                {participants.map(p => (
                  <Nav.Item key={p.id}>
                    <Nav.Link eventKey={p.id.toString()}>
                      <FontAwesomeIcon icon={faUser} className="me-1" />{' '}
                      {p.firstname} {p.lastname}
                    </Nav.Link>
                  </Nav.Item>
                ))}
                {isRegistrationOpen && (
                  <Nav.Item>
                    <Nav.Link eventKey="add">
                      <FontAwesomeIcon icon={faPlus} className="me-1" /> Ajouter
                      un participant
                    </Nav.Link>
                  </Nav.Item>
                )}
              </Nav>
            </Card.Header>
            <Card.Body>
              {activeTab === 'summary' && (
                <>
                  {participants.length === 0 && !isRegistrationOpen && (
                    <p>
                      Aucun participant n'a été inscrit et les inscriptions sont
                      closes.
                    </p>
                  )}
                  {participants.length === 0 && isRegistrationOpen && (
                    <div className="text-center py-4">
                      <div className="mb-3">
                        <FontAwesomeIcon
                          icon={faUsers}
                          size="3x"
                          className="text-muted"
                        />
                      </div>
                      <p className="lead mb-3">
                        Aucun participant n'a encore été ajouté à ce salon.
                      </p>
                      <Button
                        variant="primary"
                        size="lg"
                        onClick={() => handleTabChange('add')}
                      >
                        <FontAwesomeIcon icon={faUserPlus} className="me-2" />{' '}
                        Ajouter un participant
                      </Button>
                    </div>
                  )}
                  {participants.length > 0 && (
                    <Table responsive striped hover className="mb-0">
                      <thead>
                        <tr>
                          <th style={{ width: '30%' }}>Participant</th>
                          <th style={{ width: '60%' }}>Souhaite rencontrer</th>
                          <th style={{ width: '10%' }} className="text-center">
                            Total
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {getWishSummary().map(item => (
                          <tr key={item.participant.id}>
                            <td>
                              <Button
                                variant="link"
                                className="p-0 text-decoration-none"
                                onClick={() =>
                                  setActiveTab(item.participant.id.toString())
                                }
                              >
                                <strong>{item.participant.lastname}</strong>{' '}
                                {item.participant.firstname}
                              </Button>
                            </td>
                            <td>
                              {item.wishedCompanies.length > 0 ? (
                                <div className="d-flex flex-wrap gap-1">
                                  {item.wishedCompanies
                                    .slice(0, 5)
                                    .map(company => (
                                      <Badge
                                        bg="light"
                                        text="dark"
                                        key={company.id}
                                        className="border"
                                      >
                                        {company.name}
                                      </Badge>
                                    ))}
                                  {item.wishedCompanies.length > 5 && (
                                    <Badge bg="secondary" pill>
                                      +{item.wishedCompanies.length - 5}
                                    </Badge>
                                  )}
                                </div>
                              ) : (
                                <span className="text-muted fst-italic">
                                  Aucun partenaire sélectionné
                                </span>
                              )}
                            </td>
                            <td className="text-center">
                              <Badge bg="primary" pill>
                                {item.count}
                              </Badge>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </>
              )}

              {participants.map(
                participant =>
                  activeTab === participant.id.toString() && (
                    <div key={participant.id}>
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0">
                          Vœux pour {participant.firstname}{' '}
                          {participant.lastname}
                        </h5>
                        {isRegistrationOpen && (
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() =>
                              confirmDeleteParticipant(participant)
                            }
                          >
                            <FontAwesomeIcon icon={faTrash} className="me-1" />{' '}
                            Supprimer
                          </Button>
                        )}
                      </div>
                      <Row className="mb-3">
                        <Col md={8}>
                          <Form.Control
                            type="text"
                            placeholder="Rechercher une société..."
                            value={searchCompany}
                            onChange={e => setSearchCompany(e.target.value)}
                          />
                        </Col>
                        <Col
                          md={4}
                          className="d-flex justify-content-end align-items-center"
                        >
                          <Form.Check
                            type="switch"
                            id={`show-only-wished-switch-${participant.id}`} // Modifié l'ID pour correspondre
                            label="Voir uniquement mes vœux" // Modifié le label
                            checked={showOnlyWishedToggle} // Utilise le nouvel état
                            onChange={
                              () =>
                                setShowOnlyWishedToggle(!showOnlyWishedToggle) // Inverse la logique du nouvel état
                            }
                          />
                        </Col>
                      </Row>
                      {(() => {
                        const companiesToDisplayCurrentTab =
                          showOnlyWishedToggle // Condition inversée
                            ? filteredCompaniesForDisplay.filter(c =>
                                isCompanyWishedByParticipant(
                                  participant.id,
                                  c.id
                                )
                              )
                            : filteredCompaniesForDisplay;

                        if (
                          companiesToDisplayCurrentTab.length === 0 &&
                          showOnlyWishedToggle
                        )
                          return (
                            <p>
                              Aucun vœu sélectionné. Décochez le filtre
                              ci-dessus pour voir toutes les sociétés.
                            </p>
                          );
                        if (
                          companiesToDisplayCurrentTab.length === 0 &&
                          !showOnlyWishedToggle
                        )
                          return <p>Aucune société trouvée.</p>;

                        companiesToDisplayCurrentTab.sort(
                          sortByPartnerCompanyAndName
                        );

                        return (
                          <Row xs={1} md={2} lg={3} className="g-3">
                            {companiesToDisplayCurrentTab.map(company => {
                              const isWished = isCompanyWishedByParticipant(
                                participant.id,
                                company.id
                              );

                              const renderTooltip = props => {
                                let tooltipContent = '';
                                const categoryName =
                                  company.partner_category_name;
                                const description = company.description;

                                if (categoryName && description) {
                                  tooltipContent = `${categoryName} - ${description}`;
                                } else if (categoryName) {
                                  tooltipContent = categoryName;
                                } else if (description) {
                                  tooltipContent = description;
                                } else {
                                  tooltipContent = 'Aucune description';
                                }

                                return (
                                  <Tooltip
                                    id={`tooltip-${company.id}`}
                                    {...props}
                                  >
                                    {tooltipContent}
                                  </Tooltip>
                                );
                              };

                              return (
                                <Col key={company.id}>
                                  <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={renderTooltip}
                                  >
                                    <Card
                                      className={`company-card h-100 ${
                                        isWished ? 'selected-company' : ''
                                      } ${
                                        company.is_favorite
                                          ? 'partner-company'
                                          : ''
                                      }`}
                                      style={{
                                        cursor: isRegistrationOpen
                                          ? 'pointer'
                                          : 'default'
                                      }}
                                      onClick={() =>
                                        isRegistrationOpen &&
                                        toggleParticipantWish(
                                          participant.id,
                                          company.id,
                                          isWished
                                        )
                                      }
                                    >
                                      <Card.Body className="p-3 d-flex align-items-center justify-content-between">
                                        <span className="d-flex align-items-center">
                                          {isWished && (
                                            <FontAwesomeIcon
                                              icon={faHandshake}
                                              className="text-success me-2"
                                            />
                                          )}
                                          {!isWished && (
                                            <FontAwesomeIcon
                                              icon={faBuilding}
                                              className="text-muted me-2"
                                            />
                                          )}
                                          {company.name}
                                        </span>
                                        {company.is_favorite && (
                                          <Badge bg="info" pill>
                                            Favoris
                                          </Badge>
                                        )}
                                      </Card.Body>
                                    </Card>
                                  </OverlayTrigger>
                                </Col>
                              );
                            })}
                          </Row>
                        );
                      })()}
                    </div>
                  )
              )}
            </Card.Body>
          </Card>
        </Container>
      </Section>
      <Modal
        show={showDeleteConfirm}
        onHide={() => setShowDeleteConfirm(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmer la suppression</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Êtes-vous sûr de vouloir supprimer{' '}
          <strong>
            {participantToDelete?.firstname} {participantToDelete?.lastname}
          </strong>{' '}
          et tous ses vœux ?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDeleteConfirm(false)}
          >
            Annuler
          </Button>
          <Button variant="danger" onClick={deleteParticipant}>
            Supprimer
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showFavoritePartnersModal}
        onHide={() => setShowFavoritePartnersModal(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header>
          <Modal.Title>Sélectionnez vos partenaires privilégiés</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Pour personnaliser votre expérience, veuillez indiquer les
            partenaires avec lesquels votre société travaille régulièrement. Ces
            partenaires seront marqués comme "Favoris". Cliquez sur un
            partenaire pour le sélectionner.
          </p>
          {allPartners && allPartners.length > 0 ? (
            <Row xs={1} sm={2} md={3} className="g-3">
              {allPartners.map(partner => {
                const isSelected = selectedFavoritePartnerIdsInModal.includes(
                  partner.id
                );
                return (
                  <Col key={partner.id}>
                    <Card
                      className={`h-100 shadow-sm modal-partner-card ${
                        isSelected
                          ? 'border-warning selected-modal-favorite'
                          : 'border-light'
                      }`}
                      style={{
                        cursor: 'pointer',
                        borderWidth: isSelected ? '2px' : '1px',
                        borderColor: isSelected ? '#ffc107' : '' // Couleur explicite pour la bordure sélectionnée
                      }}
                      onClick={() =>
                        handleFavoritePartnerSelectionInModal(partner.id)
                      }
                    >
                      <Card.Body className="p-3 d-flex justify-content-between align-items-center">
                        <span className="partner-name fw-medium">
                          {partner.name}
                        </span>
                        {isSelected && (
                          <FontAwesomeIcon
                            icon={faStar}
                            className="text-warning fa-lg"
                          />
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          ) : (
            <p className="text-muted text-center">
              Aucun partenaire disponible pour ce salon.
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => setShowFavoritePartnersModal(false)}
          >
            Plus tard
          </Button>
          <Button
            variant="primary"
            onClick={handleSaveFavoritePartners}
            disabled={!allPartners || allPartners.length === 0}
          >
            Enregistrer les favoris
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showAddParticipantModal}
        onHide={() => {
          setShowAddParticipantModal(false);
          setSelectedUserIdToAdd('');
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Ajouter un participant de votre société</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Utiliser salonDetails.eligibleUsers ou eligibleUsers si destructuré plus haut */}
          {eligibleUsers && eligibleUsers.length > 0 ? (
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>
                  Sélectionner un collaborateur à inscrire :
                </Form.Label>
                <Form.Select
                  value={selectedUserIdToAdd}
                  onChange={e => setSelectedUserIdToAdd(e.target.value)}
                  aria-label="Sélectionner un utilisateur"
                >
                  <option value="">-- Choisissez un collaborateur --</option>
                  {eligibleUsers.map(user => (
                    <option key={user.id} value={user.id}>
                      {(user.lastname || '').toUpperCase()}{' '}
                      {user.firstname || ''} ({user.email})
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
          ) : (
            <Alert variant="info">
              <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
              Aucun autre collaborateur de votre société (ou de ses filiales
              directes) ne peut être ajouté à ce salon. Ils sont peut-être déjà
              tous inscrits ou aucun autre utilisateur n'est disponible.
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowAddParticipantModal(false);
              setSelectedUserIdToAdd('');
            }}
          >
            Annuler
          </Button>
          <Button
            variant="primary"
            onClick={addParticipant}
            disabled={
              !selectedUserIdToAdd ||
              !eligibleUsers ||
              eligibleUsers.length === 0
            }
          >
            Ajouter ce participant
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SalonDetail;
